import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Panel } from 'primereact/panel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputComponent } from '../../../../components/InputComponent';
import { ProveedorService } from '../../../../service/ProveedorService';
import { CatalogoService } from '../../../../service/CatalogoService';
import { useToken } from '../../../../components/useToken';
import * as generic from '../../../../components/Generico';
import { MonitoreoService } from '../../../../service/monitoreo/MonitoreoService';
import { InfoGeneral } from '../../../../models/ficha/InfoGeneral';
import { InputActividadEconomica } from '../../../../components/ui/Formularios/InputActividadEconomica';
import { BottomActionBar } from '../../../../components/ui/BottomActionBar';

export const DatosGeneral = ({ toast, id, permss, catalogos, next, nuevoProveedor, soloLectura }) => {

    const omodel = new InfoGeneral({ tipoFrmEmpresa: catalogos?.tipoFrmEmpresa });
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError, setValue, clearErrors } = useForm({ defaultValues, shouldTrim: true, mode: 'onTouched' });
    const proveedorServicio = new ProveedorService();
    const monitoreoService = new MonitoreoService();
    const catalogoService = new CatalogoService();
    const { getPerss } = useToken();
    const siCliente = getPerss() !== undefined;
    const { inDrop, inText, inCalendar, inArea, inDropMultiple } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    // Estados Locales de UI (Carga y guardado)
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    // Estados Lógicos
    const [ecuador, setEcuador] = useState(false);
    const [ecuadorDireccion, setEcuadorDireccion] = useState(false);
    const [ciudades, setCiudades] = useState([]);
    const [ciudadesDireccion, setCiudadesDireccion] = useState([]);
    const [esRuc, setEsRuc] = useState(false);
    const [esCedula, setEsCedula] = useState(false);
    const [siCompania, setSiCompania] = useState(true);
    const [empresasGrupo, setEmpresasGrupo] = useState([]);

    useEffect(() => {
        editFicha();
        // eslint-disable-next-line
    }, [id]);

    const onSubmit = (data) => {
        setIsSaving(true);
        data.ec = catalogos?.ecuador;
        data.ruc = catalogos?.ruc;
        data.fecha = generic.dateToString(data.fecha);
        data.fecha_inicio = generic.dateToString(data.fecha_inicio);
        if (catalogos?.tipoFrmEmpresa === 'FRM_DIFARE' && data.fecha_constitucion) {
            data.fecha_constitucion = generic.dateToString(data.fecha_constitucion);
        }
        data.tipoFrmEmpresa = catalogos?.tipoFrmEmpresa;
        // Auto asignar grupo si solo hay 1
        if (!data.grupo && catalogos?.grupos?.length === 1) {
            data.grupo = catalogos.grupos[0];
        }
        data.seccion = 'seccion1';
        const request = id == null ? proveedorServicio.newProveedor(data) : proveedorServicio.editarProveedor({ ...data, id });
        request.then(res => {
            nuevoProveedor(res.data);
            generic.funcSuccess(res, toast);
            next();
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => {
            setIsSaving(false);
        });
    }

    const editFicha = () => {
        setIsLoading(true);
        proveedorServicio.consultarProveedor(id ?? 0, { seccion: 'seccion1', tipoFrmEmpresa: catalogos?.tipoFrmEmpresa }).then(res => {
            const _prov = res.data.proveedor;
            const cats = catalogos;

            setCiudades(res.data.ciudades || []);
            setCiudadesDireccion(res.data.direccion_ciudades || []);
            setEmpresasGrupo(cats?.catalogo_registro_grupo || []);

            if (!_prov) {
                reset(defaultValues);
                if (cats?.nombreEmpresa) setValue('compania', cats.nombreEmpresa);
                if (cats?.grupos?.length > 0) setSiCompania(false);

                // Auto asignaciones sin peticiones extra al servidor
                if (cats?.grupos?.length === 1) {
                    setValue('grupo', cats.grupos[0]);
                } else if (!cats?.grupos?.length && cats?.empresas?.length === 1) {
                    setValue('empresa_registro', cats.empresas[0]);
                }
                setIsLoading(false);
                return;
            }

            if (cats?.grupos?.length > 0) setSiCompania(false);
            setEcuador(_prov.pais?.cat_id === cats.ecuador?.cat_id);
            setEcuadorDireccion(_prov.direccion_pais?.cat_id === cats.ecuador?.cat_id);
            setEsRuc(_prov.tipo_identificacion?.cat_id === cats.ruc?.cat_id);
            setEsCedula(_prov.tipo_identificacion?.cat_id === cats.cedula?.cat_id);

            // Formateo de fechas
            _prov.fecha = generic.stringToDate(_prov.fecha);
            _prov.fecha_inicio = generic.stringToDate(_prov.fecha_inicio);
            if (cats?.tipoFrmEmpresa === 'FRM_DIFARE') {
                _prov.fecha_constitucion = generic.stringToDate(_prov.fecha_constitucion);
            }

            // Asignar el grupo para registros existentes si solo hay uno
            if (cats?.grupos?.length === 1) {
                setValue('grupo', cats.grupos[0]);
            }

            reset(generic.renewValues(_prov, omodel.model));
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    // Handlers OnChange
    const onChangePais = (e, dirr) => {
        if (dirr) setEcuador(e.value?.cat_id === catalogos.ecuador?.cat_id);
        else setEcuadorDireccion(e.value?.cat_id === catalogos.ecuador?.cat_id);
    }

    const onChangeProvincia = (e, dirr) => {
        if (!e?.value) {
            if (dirr) setCiudades([]);
            else setCiudadesDireccion([]);
            return;
        }
        catalogoService.getCatalogosId(e.value.cat_id).then(res => {
            if (dirr) setCiudades(res.data);
            else setCiudadesDireccion(res.data);
        });
    }

    const onChangeTipo = (e) => {
        setEsRuc(e.value?.cat_id === catalogos.ruc?.cat_id);
        setEsCedula(e.value?.cat_id === catalogos.cedula?.cat_id);
        clearErrors('identificacion');
    }

    const onChangeGrupo = (e) => {
        setValue('empresas_seleccionadas', []);
        if (e.value) {
            const grupoId = e.value.cat_id ?? e.value;
            monitoreoService.consultar(grupoId, 'administracion/usuario-empresa/listar-empresas-grupo').then((res) => {
                setEmpresasGrupo(res.data || []);
            }).catch((error) => {
                generic.funcSistemaError(error, toast);
            });
        } else {
            setEmpresasGrupo([]);
        }
    }

    const tipoDoc = esRuc ? 'IDEN_RUC' : esCedula ? 'IDEN_CEDULA' : null;

    const reglaValidacion = (val) => {
        // Si no es RUC ni Cédula (ej. Análogo u otros), es válido por defecto
        if (!tipoDoc) return true;
        return generic.validarIdentificacionEcuador(val, tipoDoc) || `${esRuc ? 'RUC' : 'Cédula'} incorrecto`;
    };

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <form onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">
            <div className="surface-card p-4 shadow-1 border-round mb-4">
                <div className="formgrid grid">
                    <div className="col-12 mb-3">
                        <div className="flex align-items-center">
                            <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                <i className="pi pi-file-edit text-primary"></i>
                                INFORMACIÓN DE REGISTRO
                            </span>
                            <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                        </div>
                    </div>

                    {catalogos?.grupos?.length > 1 && inDrop('grupo', catalogos?.grupos, { lab: omodel.optionLabel, chn: onChangeGrupo }, 4)}
                    {empresasGrupo.length > 0 &&
                        inDropMultiple('empresas_seleccionadas', empresasGrupo, { lab: omodel.optionLabel }, catalogos?.grupos?.length > 1 ? 4 : 6)
                    }
                    {!siCliente && catalogos?.empresas?.length > 0 &&
                        inDrop('empresa_registro', catalogos?.empresas, { lab: omodel.optionLabel }, (catalogos?.grupos?.length > 1 && empresasGrupo.length > 0) ? 4 : 6)
                    }

                    {inCalendar('fecha', {}, 3)}
                    {inDrop('pais', catalogos?.pais, { lab: omodel.optionLabel, chn: (e) => onChangePais(e, true) }, 3)}
                    {ecuador ? (
                        <>
                            {inDrop('provincia', catalogos?.provincias, { lab: omodel.optionLabel, chn: (e) => onChangeProvincia(e, true) }, 3)}
                            {inDrop('ciudad', ciudades, { lab: omodel.optionLabel }, 3)}
                        </>
                    ) : (
                        inText('canton', { icon: 'pi pi-map-marker' }, 6)
                    )}

                    <div className="col-12 mb-3 mt-3">
                        <div className="flex align-items-center">
                            <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                <i className="pi pi-cog text-primary"></i>
                                TIPO DE DECLARACIÓN
                            </span>
                            <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                        </div>
                    </div>

                    {inDrop('tipo_persona', catalogos?.tipo, { lab: omodel.optionLabel }, omodel.model.proyecto.table ? 4 : 6)}
                    {inDrop('tipo_informacion', catalogos?.declaracion, { lab: omodel.optionLabel }, omodel.model.proyecto.table ? 4 : 6)}
                    {omodel.model.proyecto.table && inDrop('proyecto', generic.estadosSiNo, { lab: omodel.optionLabel, etiqueta: catalogos?.tcompania?.etiqueta }, 4)}

                    {omodel.model.compania.table && siCompania && inText('compania', { icon: 'pi pi-briefcase' }, 12)}
                </div>
            </div>

            <Panel header={generic.renderPanelHeader('1', 'Información General', 'pi pi-id-card')} className="panel-ficha shadow-1">
                <div className="formgrid grid">
                    {inDrop('tipo_identificacion', catalogos?.tipo_identificacion, { lab: omodel.optionLabel, chn: onChangeTipo }, omodel.model.fecha_constitucion.table ? 3 : 4)}
                    {inText('identificacion', { validate: reglaValidacion, icon: 'pi pi-id-card' }, omodel.model.fecha_constitucion.table ? 3 : 4)}
                    {omodel.model.fecha_constitucion.table && inCalendar('fecha_constitucion', {}, 3)}
                    {inCalendar('fecha_inicio', {}, omodel.model.fecha_constitucion.table ? 3 : 4)}

                    {esRuc && inText('razon_social', { icon: 'pi pi-building' }, 12)}
                    {!esRuc && inText('nombres', { icon: 'pi pi-user' }, 6)}
                    {!esRuc && inText('apellidos', { icon: 'pi pi-user' }, 6)}

                    <InputActividadEconomica name="actividad" control={control} modelDef={omodel.model['actividad']} disabled={soloLectura} col={12} />

                    {inText('web', { icon: 'pi pi-globe' }, 12)}

                    <div className="col-12 my-3">
                        <div className="flex align-items-center">
                            <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                <i className="pi pi-map-marker text-primary"></i>
                                DIRECCIÓN Y CONTACTO
                            </span>
                            <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                        </div>
                    </div>

                    {inDrop('direccion_pais', catalogos?.pais, { lab: omodel.optionLabel, chn: (e) => onChangePais(e, false) }, ecuadorDireccion ? 4 : 6)}
                    {ecuadorDireccion ? (
                        <>
                            {inDrop('direccion_provincia', catalogos?.provincias, { lab: omodel.optionLabel, chn: (e) => onChangeProvincia(e, false) }, 4)}
                            {inDrop('direccion_ciudad', ciudadesDireccion, { lab: omodel.optionLabel }, 4)}
                        </>
                    ) : (
                        inText('direccion_canton', { icon: 'pi pi-map-marker' }, 6)
                    )}

                    {inArea('direccion_oficina', 3, 100, 12)}

                    {!ecuadorDireccion ? (
                        <>
                            {inText('codigo_postal', { icon: 'pi pi-envelope' }, 6)}
                            {inText('telefono', { icon: 'pi pi-phone' }, 6)}
                        </>
                    ) : (
                        inText('telefono', { icon: 'pi pi-phone' }, 12)
                    )}
                </div>
            </Panel>

            <BottomActionBar onNext={next} loading={isSaving} isReadOnly={soloLectura} />
        </form>
    );
}